import {CriterionRoute} from "@/router/Evaluation/CriterionRoute";

export const EvaluationRecruitmentFile = {
    path: '/evaluation_recruitment_files',
    name: 'evaluation_recruitment_files',
    component: () => import('@/views/Evaluation/File/EvaluationRecruitmentFilePage.vue'),
    children: [
        {
            path: '/evaluation_recruitment_files/add',
            name: 'evaluation_recruitment_files.add',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_RECRUITMENT',
            },
            children: [
                ...CriterionRoute('evaluation_recruitment_files.add',
                    'EVALUATION_RECRUITMENT_CRITERION_CATEGORY',
                    'EVALUATION_RECRUITMENT')
            ]
        },
        {
            path: '/evaluation_recruitment_files/edit/:id',
            name: 'evaluation_recruitment_files.edit',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_RECRUITMENT',
            },
            children: [
                ...CriterionRoute('evaluation_recruitment_files.edit',
                    'EVALUATION_RECRUITMENT_CRITERION_CATEGORY',
                    'EVALUATION_RECRUITMENT')
            ]
        },
        {
            path: '/evaluation_recruitment_files/duplicate/:id',
            name: 'evaluation_recruitment_files.duplicate',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: { 
                duplicateAction: true,
                type: 'EVALUATION_RECRUITMENT',
            },
            children: [
                ...CriterionRoute('evaluation_recruitment_files.duplicate',
                    'EVALUATION_RECRUITMENT_CRITERION_CATEGORY',
                    'EVALUATION_RECRUITMENT')
            ]
        },
        {
            path: '/evaluation_recruitment_files/bulk_update',
            name: 'evaluation_recruitment_files.bulk_update',
            component: () => import('@/views/Evaluation/File/Form/BulkUpdateForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_RECRUITMENT',
            },
            children: [
                ...CriterionRoute('evaluation_recruitment_files.bulk_update',
                    'EVALUATION_RECRUITMENT_CRITERION_CATEGORY',
                    'EVALUATION_RECRUITMENT')
            ]
        },
        {
            path: '/evaluation_recruitment_files/delete/:id',
            name: 'evaluation_recruitment_files.delete',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
        {
            path: '/evaluation_recruitment_files/view/:id',
            name: 'evaluation_recruitment_files.view',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
        {
            path: '/evaluation_recruitment_files/archive/:id',
            name: 'evaluation_recruitment_files.archive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: { 
                archiveAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
        {
            path: '/evaluation_recruitment_files/unarchive/:id',
            name: 'evaluation_recruitment_files.unarchive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: { 
                unarchiveAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
    ]
}